import React from 'react';
import PropTypes from 'prop-types';
import { NeuroMessage } from '../../components';
import {useProduct} from '../../hooks';

const CTProduct = ({
  enableProductDetails,
  enableProductIds,
  enableMatchedRules,
  enableRules,
  enableCalculations,
  product,
}) => {
  const {
    description,
    descriptionAbbreviated,
    disclosures,
    features
  } = useProduct(product);
  const componentClass = 'product';

  const defaultDetails = (
    <div className={`${componentClass}__details`}>
      <div>{descriptionAbbreviated}</div>
    </div>
  );

  const extendedDetails = (
    <div className={`${componentClass}__details`}>
      <div>
        <h6>
          <b>Description Abbreviated:</b>
        </h6>
        {descriptionAbbreviated || 'N/A'}
      </div>
      <div>
        <h6>
          <b>Description:</b>
        </h6>
        {description || 'N/A'}
      </div>
      <div>
        <h6>
          <b>Features:</b>
        </h6>
        {(features && features.length && (
          <ul>
            {features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        )) ||
          'N/A'}
      </div>
      <div>
        <h6>
          <b>Disclosures:</b>
        </h6>
        {(disclosures && disclosures.length && (
          <ul>
            {disclosures.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        )) ||
          'N/A'}
      </div>
    </div>
  );

  return (
    <div className="product" id={product.id} key={product.id}>
      <NeuroMessage id={`${product.id}.name`} className={`${componentClass}__header`} tagName="div"/>
      {enableProductIds && (
        <label>
          <small>
            <b>Product ID: </b> {product.id}
          </small>
        </label>
      )}
      {enableProductDetails ? extendedDetails : defaultDetails}
      {enableMatchedRules && product.matchedRule && (
        <div>
          <br/>
          <div><strong>Matched Rules: </strong>{product.matchedRule.criteria.map(
            (criteria, i) => <div key={i}>{criteria}</div>
          )}</div>
        </div>
      )}
      {enableRules && product.rules && (
        <div>
          <br/>
          <div>
            <strong>Rules: </strong>
            {product.rules.map((rule, i) => (
              <div key={i} style={{ color: '#aaa', backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '5px', marginBottom: '10px' }}>
                {rule.criteria.map((criteria, j) => (
                  <div key={j}>
                    {criteria}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
      {enableCalculations && product.answers && (
        <div>
          <br/>
          <div>
            <strong>Calculations: </strong>
            {product.answers.filter(answer => answer.type === 'number').map((calc, i) => (
              <div key={i}><b>{ calc.appkey }:</b> <i>${ calc.value }</i></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

CTProduct.propTypes = {
  enableProductDetails: PropTypes.bool,
  enableProductIds: PropTypes.bool,
  enableMatchedRules: PropTypes.bool,
  enableCalculations: PropTypes.bool,
  enableRules: PropTypes.bool,
  product: PropTypes.any,
};

export default CTProduct;
